import { Nullable } from '../../foundation'

import type { ConsultationState } from './Consultation'

export enum ProcessStatus {
  PENDING = 'PENDING',
  APPOINTED = 'APPOINTED',
  INPROGRESS = 'INPROGRESS',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
}

export interface UserConsultation {
  id: number
  type: 'RESERVATION' | 'CONSULTATION'
  createdAt: string
  operationType: 'SURGICAL' | 'NONSURGICAL' | 'UNKNOWN'
  consState: ConsultationState
  processStatus: ProcessStatus

  isChat: boolean
  chatRoomId: string

  offlinePointRedeemAmount: number
  offlinePointCurrency: string

  memberId: number
  hospitalId: number
  purchaseId: Nullable<number>
  requestedReservedAt: Nullable<string> /* 고객이 요청한 내원 일시 */
  requestedReservedAtList: Nullable<string[]>
  confirmedReservedAt: Nullable<string> /* 병원이 확정한 내원 일시 */
  originType: 'EVENT' | 'TENDER' | 'DOCTOR' /* TENDER: 병원 */
  originId: number
  originTitle: string
  originImage: string
  specialOfferPrice: Nullable<number>

  memberName: string
  memberPhoneNumber: Nullable<string>
  memberEmail: Nullable<string>
  memberCountry: string
  isReviewed: boolean
  orderId: Nullable<string>
}
